// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@keyframes spin{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}.fade-render-active{transition:all .3s;transform:translateZ(0)}.fade-render{opacity:0;transform:translate3d(0,-60px,0)}", ""]);
// Exports
module.exports = exports;
